import { render, staticRenderFns } from "./Intro.vue?vue&type=template&id=7b2ebff4"
var script = {}
import style0 from "./Intro.vue?vue&type=style&index=0&id=7b2ebff4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports